import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AufgabeEintragDto } from "@app/dto/aufgabe.eintrag.dto";
import { AufgabeErledigtDto } from "@app/dto/aufgabe.erledigt.dto";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AufgabenService {
    private _baseUrl = `${environment.apiHost}/${environment.apiBaseUrl}`;

    currentAufgabe: AufgabeEintragDto = {
        id:                     "",
        aufgabeText:            "",
        datum:                  null,
        realDate:               null,
        adaIstSicher:           false,
        vertrauensIndikator:    0,
        aufgabenTyp:            "",
        erledigtVon:            "",
        erledigtAm:             "",
        pcAdressnummer:         0,
        firmenname:             "",
        strasseUndHausnummer:   "",
        plz:                    "",
        ort:                    "",
        nlCode:                 0,
        aufgabenpakete:         [],
        original:               null,
        azureSearchOriginal:    [],
        azureSearchESW:         [],
        ESW:                    []
    };

    public constructor(
        private readonly http: HttpClient,
    ) { }

    public getAufgabenList(filter: string, take: number): Observable<{ anzahlBasierendAufFilter: number, aufgabenAsJsonString: string }> {
        const skip:number = 0;
        return this.http.get<{ anzahlBasierendAufFilter: number, aufgabenAsJsonString: string }>(`${this._baseUrl}/aufgaben/duplikatspruefung/offen`, { params: { filter, take, skip } });
    }

    public getESWList(filter: string): Observable<[]> {
        return this.http.get<[]>(`${this._baseUrl}/aufgaben/ESWLookup?maxcount=100${filter}`, {});
    }

    public markAsResolved(aufgabeErledigt: AufgabeErledigtDto): Observable<string> {
        return this.http.put<string>(`${this._baseUrl}/aufgaben`, aufgabeErledigt);
    }
}